import { AfterViewChecked, ChangeDetectorRef, Component, inject } from '@angular/core';
import { Subscription } from 'rxjs';

// libs
import { BaseComponent } from '../../../core/base/base-component';

@Component({
  template: '',
  standalone: false,
})
export abstract class LayoutBaseComponent extends BaseComponent implements AfterViewChecked {
  protected cd = inject(ChangeDetectorRef);

  public appName: string;
  subscription: Subscription;

  ngAfterViewChecked() {
    // helps solves ExpressionChangedAfterItHasBeenCheckedError exception with angular
    this.cd.detectChanges();
  }
}
